import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Button, Form, Grid, Segment } from "semantic-ui-react";
import { Form as FinalForm, Field } from "react-final-form";
import TextInput from "../../../app/common/form/TextInput";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadComponent from "../../../app/layout/LoadComponent";
import TeacherList from "./TeacherList";
import { Link } from "react-router-dom";

const TeacherDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadingInitial, loadTeachers, teacherFilter, setPredicate } =
    rootStore.teacherStore;

  useEffect(() => {
    loadTeachers();
  }, [loadTeachers]);

  if (loadingInitial)
    return <LoadComponent content="Carregando professores..." />;

  const handleSubmitFilter = (values: any) => {
    const { ...filter } = values;
    teacherFilter.name = filter.name;
    setPredicate();
  };

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={14}>
          <h1>Professores</h1>
        </Grid.Column>
        <Grid.Column width={2}>
          <Button
            as={Link}
            to="/admin/novoprofessor"
            active
            positive
            content="Novo"
            floated="right"
            style={{ marginTop: "12px" }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <Segment>
            <h2>Filtros</h2>
            <Segment>
              <FinalForm
                initialValues={teacherFilter}
                onSubmit={handleSubmitFilter}
                render={({ handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Field
                        name="name"
                        placeholder="Nome"
                        value={teacherFilter!.name}
                        component={TextInput}
                        width={3}
                      />
                      <Button content="Pesquisar" />
                    </Form.Group>
                  </Form>
                )}
              />
            </Segment>
          </Segment>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <TeacherList />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default observer(TeacherDashboard);
